import { AppState } from '../../reducers';

export function selectProductLayout(state: AppState) {
  const { userSelectedLayout } = state.areas.productCollection;

  return userSelectedLayout;
}

export const selectSponsoredProducts = (state: AppState) => {
  const { sponsoredProducts } = state.areas.productCollection;

  return Array.isArray(sponsoredProducts) ? sponsoredProducts : [];
};
